import React from 'react';
import styled, { StyledComponent } from 'styled-components';
import { SunbitQRCode } from '../../../ui/qr-code/qr-code';
import { Button } from '../../../ui/button/Button';
import shieldIcon from '../../../assets/card-apply/icons/shield-verify.svg';
import Title from '../../components/title/Title';
import * as styles from './styles';
import { SMSLinkModal } from '../../components/SMSLinkModal/smsLinkModal';

interface ExtraVerificationProps {
  link: string;
  className?: string;
  sendAgainCountDown: number;
  customerPhoneNumber?: string;
  onSendSMS: VoidFunction;
}

export const Verification: StyledComponent<React.FC<ExtraVerificationProps>, {}> = styled(({ className, link, sendAgainCountDown, customerPhoneNumber, onSendSMS }: ExtraVerificationProps) => {
  const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);

  const handleClick = () => {
    setIsModalOpen(true);
    onSendSMS();
  };
  return (
    <div className={className}>
      <img src={shieldIcon} />
      <div className={'text'}>
        <Title className={'title'} data-at={'extra-verify-title'}>
          Help us protect your identity.
        </Title>
        <div className={'explain-text'} data-at={'extra-verify-explain'}>
          Please follow the QR code or click the button below to get a link sent to your phone, where you can complete the verification process to protect your information.
        </div>
      </div>
      <SunbitQRCode dimension={105} className={'qr-container'} link={link} />
      <Button dataAt={'extra-verify-send-link-btn'} onClick={handleClick} className={'send-link-btn'}>
        Text me a link
      </Button>
      {isModalOpen && (
        <SMSLinkModal handleSendAgainLink={onSendSMS} sendAgainCountDown={sendAgainCountDown} onClose={() => setIsModalOpen(false)} link={link} lastPhoneNumbers={customerPhoneNumber?.slice(-4)} />
      )}
    </div>
  );
})`
  ${styles.ExtraVerification}
`;
